export const directions = [
	'unknown',
	'up',
	'down',
	'left',
	'right',
	'up_left',
	'up_right',
	'down_left',
	'down_right',
] as const;
